import React from 'react';
import { connect } from 'react-redux';

import * as uiActions from '../../redux/ui/actions';
import * as uiSelectors from '../../redux/ui/selectors';

import NavigationMobile from './NavigationMobile';

const NavigationMobileConnected = (props) => <NavigationMobile {...props} />;

const mapStateToProps = (state) => ({
  isVisible: uiSelectors.selectIsMobileNavVisible(state),
});

const mapActionsToProps = {
  hideMobileNav: uiActions.hideMobileNav,
  showMobileNav: uiActions.showMobileNav,
};

export default connect(mapStateToProps, mapActionsToProps)(NavigationMobileConnected);
